const ACCESS_TOKEN = "accessToken";
const USER = "user";

export function setAccessToken(token) {
  sessionStorage.setItem(ACCESS_TOKEN, token);
}

export function getAccessToken() {
  return sessionStorage.getItem(ACCESS_TOKEN);
}

export function removeAccessToken() {
  sessionStorage.removeItem(ACCESS_TOKEN);
}

export function setUser(user) {
  sessionStorage.setItem(USER, JSON.stringify(user));
}

export function getUser() {
  const storedUser = sessionStorage.getItem(USER);

  if (!storedUser) {
    return null;
  }

  try {
    return JSON.parse(storedUser);
  } catch {
    removeUser();
    return null;
  }
}

export function removeUser() {
  sessionStorage.removeItem(USER);
}